import React, {Suspense} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {useEffect} from 'react'
import {GlobalLoading} from './components/loading/GlobalLoading'
import './api'
import {startAnalytics, trackPageView} from './analytics/analyticsClient'

// Initialize Feature Flags
import './data-layer/featureflags'

export const MyContext = React.createContext(null)

declare global {
  interface Window {
    gtag: any
  }
}

const App = () => {
  const location = useLocation()
  const {currentUser} = useAuth()
  const isServiceLevel = /^\/service-level(?:\/|$)/.test(location.pathname)

  useEffect(() => {
    if (currentUser) startAnalytics()
  }, [currentUser])

  useEffect(() => {
    if (currentUser) trackPageView(location.pathname)
  }, [currentUser, location.pathname])

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
            {isServiceLevel && <GlobalLoading />}
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
